import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-check-admin-pass',
  templateUrl: './check-admin-pass.component.html',
  styleUrls: ['./check-admin-pass.component.scss']
})
export class CheckAdminPassComponent implements OnInit {
  AdminPassValue!: any;
  enteredPasscode: string = '';
  errorMessage: string = '';

  constructor(
    public dialogRef: MatDialogRef<CheckAdminPassComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService
  ) {
    this.AdminPassValue = data.adminPassValue; 
  }

  ngOnInit(): void {
  }
 dismiss(reason: string): void {
    this.dialogRef.close(reason);
  }

  checkPasscode(): void {
    if (this.enteredPasscode === this.AdminPassValue) {
      this.dialogRef.close('200');
      this.appService.showToast('Passcode matched');
    } else {
      this.errorMessage = 'Invalid passcode. Please try again.';
      this.appService.showToast('Invalid passcode. Please try again.');
    }
  }
}
